import { FC, useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader } from '@frontend/design-system';
import { useContactDetails } from '../../../../hooks';
import { useSendFormsStore } from '../../../../providers';
import { containerStyle } from './delivery-options.styles';
import SendAsEmail from './send-as-email/send-as-email.component';
import SendAsKioskQR from './send-as-kiosk-qr/send-as-kiosk-qr.component';
import SendAsMessage from './send-as-message/send-as-message.component';

const DeliveryOptions: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { personId, setShowMessageComponent, locationId } = useSendFormsStore([
    'personId',
    'setShowMessageComponent',
    'locationId',
  ]);
  const { getContactNumbers, isLoadingContact } = useContactDetails(personId, locationId);

  useEffect(() => {
    const contactNumbers = getContactNumbers();
    setShowMessageComponent(contactNumbers.length !== 0);
  }, [personId, locationId, getContactNumbers, setShowMessageComponent]);

  return (
    <section css={containerStyle}>
      <SendAsMessage />
      <SendAsEmail />
      <SendAsKioskQR />
      <ContentLoader show={isLoadingContact} message={t('Loading contact details...')} />
    </section>
  );
};

export default DeliveryOptions;
